import React from "react";
import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import NftRecordIcon from "./NftRecordIcon";
import Button from "../../../../common/components/Buttons/Button";
import { Paragraph14Bold } from "../../../../common/Typography/Paragraph14";
import { Paragraph16Regular } from "../../../../common/Typography/Paragraph16";

const Root = styled.div``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    max-width: 290px;
  }
`;

const TitleWrapper = styled.div`
  padding-bottom: 20px;
`;

const Title = styled(Paragraph14Bold)`
  width: 100%;
  line-height: 33px;
`;

const DescriptionWrapper = styled.div`
  padding-bottom: 40px;
`;

const Description = styled(Paragraph16Regular)`
  line-height: 19px;
  padding-bottom: 20px;
`;

const NftRecordWrapper = styled.div`
  padding-bottom: 40px;
`;

const SignupButtonWrapper = styled.div`
  align-self: self-start;
`;

const SignupInfoMobile = () => {
  const { t } = useTranslation();

  return (
    <Root>
      <Container>
        <TitleWrapper>
          <Title>{t("signup-info-title")}</Title>
        </TitleWrapper>
        <DescriptionWrapper>
          <Description>{t("signup-info-description")}</Description>
        </DescriptionWrapper>
        <NftRecordWrapper>
          <NftRecordIcon />
        </NftRecordWrapper>
        <SignupButtonWrapper>
          <Button
            as={Link}
            smooth
            to="signup-box"
            text={t("signup-box-label")}
            iconName="arrowDown"
          />
        </SignupButtonWrapper>
      </Container>
    </Root>
  );
};

export default SignupInfoMobile;
